'use client'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const float = keyframes`
    0% { transform: translateY(0px); }
    50% { transform: translateY(-4px); }
    100% { transform: translateY(0px); }
`

const hueRotate = keyframes`
    0% { filter: hue-rotate(0deg) drop-shadow(0 0 5px #6366f1); }
    50% { filter: hue-rotate(180deg) drop-shadow(0 0 5px #6366f1); }
    100% { filter: hue-rotate(360deg) drop-shadow(0 0 5px #6366f1); }
`

const textHue = keyframes`
    0% { filter: hue-rotate(0deg); }
    100% { filter: hue-rotate(360deg); }
`

const LogoContainer = styled.div`
    font-family: var(--font-squada);
    font-size: ${({ size }) => size == 'large' ? '5rem' : '2.5rem'};
    font-weight: 700;
    letter-spacing: 2px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;
    user-select: none;
    margin: 0;
    transform: scale(0.85);
    


    span {
        padding-bottom: 1px;
        color: #7260ff;
        //color: #e781fd;
        //color: #18ffb3;
        //text-shadow: 0 0 10px rgba(99, 102, 241, 0.6);
        //animation: ${textHue} 10s linear infinite;
    }
`

const FloatingIcon = styled.img`
    position: absolute;
    top: 2px;
    left: -3px;
    width: 30px;
    height: 36px;
    ${({ size }) => size == 'large' && 'width: 60px; height: 78px; left: -6px;'}
    animation:
        ${float} 3s ease-in-out infinite

`

const RelativeChar = styled.span`
    position: relative;
    display: inline-block;
    width: 26px;
    height: 32px;

    ${({ size }) => size == 'large' && 'width: 52px; height: 64px;'}
`

export default function AnimatedLogo({ size }) {
    return (
        <LogoContainer size={size}>
            <span>
                C
                <RelativeChar size={size}>
                    <FloatingIcon size={size} src="/icon-cubic.png" alt="" />
                </RelativeChar>
                NFIG
            </span>
            STRIKE
        </LogoContainer>
    )
}
